// actions.js
import {
  FETCH_QUOTES_REQUEST,
  FETCH_QUOTES_SUCCESS,
  FETCH_QUOTES_FAILURE,
  DELETE_QUOTES_REQUEST,
  DELETE_QUOTES_FAILURE,
  DELETE_QUOTES_SUCCESS,
  FETCH_QUOTE_REQUEST,
  FETCH_QUOTE_SUCCESS,
  FETCH_QUOTE_FAILURE,
  UPDATE_QUOTES_REQUEST,
  UPDATE_QUOTES_SUCCESS,
  UPDATE_QUOTES_FAILURE,
  CREATE_QUOTE_REQUEST,
  CREATE_QUOTE_SUCCESS, 
  CREATE_QUOTE_FAILURE,
  QUOTE_TO_PDF_REQUEST,
  QUOTE_TO_PDF_SUCCESS, 
  QUOTE_TO_PDF_FAILURE,
  CLEAR_QUOTE_ERRORS,
  CLEAR_QUOTE_SUCCESS,
} from './actionTypes';

export const fetchQuotesRequest = () => ({
  type: FETCH_QUOTES_REQUEST,
});

export const fetchQuotesSuccess = (quotes) => ({
  type: FETCH_QUOTES_SUCCESS,
  payload: quotes,
});

export const fetchQuotesFailure = (error) => ({
  type: FETCH_QUOTES_FAILURE,
  payload: error,
});

export const fetchQuoteRequest = (id) => ({
  type: FETCH_QUOTE_REQUEST,
  payload: id
});

export const fetchQuoteSuccess = (quote) => ({
  type: FETCH_QUOTE_SUCCESS,
  payload: quote,
});

export const fetchQuoteFailure = (error) => ({
  type: FETCH_QUOTE_FAILURE,
  payload: error,
});

export const updateQuoteRequest = (quote, navigate) => ({
  type: UPDATE_QUOTES_REQUEST,
  payload: { quote, navigate }
});

export const updateQuoteSuccess = () => ({
  type: UPDATE_QUOTES_SUCCESS,
});

export const updateQuoteFailure = (error) => ({
  type: UPDATE_QUOTES_FAILURE,
  payload: error,
});

export const deleteQuoteRequest = (id) => ({
  type: DELETE_QUOTES_REQUEST,
  payload: id
});

export const deleteQuoteSuccess = (id) => ({
  type: DELETE_QUOTES_SUCCESS,
  payload: id,
});

export const deleteQuoteFailure = (error) => ({
  type: DELETE_QUOTES_FAILURE,
  payload: error,
});

export const createQuoteRequest = (id) => ({
  type: CREATE_QUOTE_REQUEST,
  payload: id,
});

export const createQuoteSuccess = (id) => ({
  type: CREATE_QUOTE_SUCCESS,
  payload: id
});

export const createQuoteFailure = (error) => ({
  type: CREATE_QUOTE_FAILURE,
  payload: error,
});

export const quoteToPdfRequest = (id) => ({
  type: QUOTE_TO_PDF_REQUEST,
  payload: id,
});

export const quoteToPdfSuccess = (quote) => ({
  type: QUOTE_TO_PDF_SUCCESS,
  payload: quote
});

export const quoteToPdfFailure = (error) => ({
  type: QUOTE_TO_PDF_FAILURE,
  payload: error,
});

export const clearQuoteErrors = () => ({
  type: CLEAR_QUOTE_ERRORS,
});

export const clearQuoteSuccess = () => ({
  type: CLEAR_QUOTE_SUCCESS,
});